import React, { useEffect, useRef, useState } from 'react';
import {
  ReadOutlined, LaptopOutlined, DatabaseOutlined, EnvironmentOutlined,
  TeamOutlined, LinkOutlined, RiseOutlined
} from '@ant-design/icons';
import '../../../Styles/ResearchLabs.css';

const metrics = [
  { value: 8, label: 'Academic Research & Development', icon: ReadOutlined },
  { value: 4, label: 'Hardware/ Software', icon: LaptopOutlined },
  { value: 116, label: 'Data & Inventory Management', icon: DatabaseOutlined },
  { value: 82, label: 'Models & Maps Development', icon: EnvironmentOutlined },
  { value: 45, label: 'Capacity Building', icon: TeamOutlined },
  { value: 20, label: 'Linkages & Commercialization', icon: LinkOutlined },
  { value: 4, label: 'Research Impact', icon: RiseOutlined },
];

const ImpactMetric = ({ metric, active }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!active) {
      setCount(0);
      return undefined;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      setCount(metric.value);
      return undefined;
    }

    let frame;
    const startedAt = performance.now();
    const duration = 1400;
    const animate = (time) => {
      const progress = Math.min((time - startedAt) / duration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      setCount(Math.round(metric.value * eased));
      if (progress < 1) frame = requestAnimationFrame(animate);
    };
    frame = requestAnimationFrame(animate);
    return () => cancelAnimationFrame(frame);
  }, [active, metric.value]);

  const Icon = metric.icon;
  return (
    <div className="sdssl-impact-card">
      <Icon className="sdssl-impact-icon" aria-hidden="true" />
      <strong className="sdssl-impact-value">{count}</strong>
      <span className="sdssl-impact-label">{metric.label}</span>
    </div>
  );
};

const ImpactSection = () => {
  const sectionRef = useRef(null);
  const [active, setActive] = useState(false);

  useEffect(() => {
    const node = sectionRef.current;
    if (!node) return undefined;
    const observer = new IntersectionObserver(
      ([entry]) => setActive(entry.isIntersecting),
      { threshold: 0.25 }
    );
    observer.observe(node);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} className="sdssl-impact-section" aria-labelledby="sdssl-impact-heading">
      <div className="sdssl-impact-overlay">
        <div className="sdssl-impact-inner">
          <h2 id="sdssl-impact-heading" className="sdssl-impact-title">Impact</h2>
          <span className="sdssl-impact-divider" aria-hidden="true" />
          <div className="sdssl-impact-grid">
            {metrics.map((metric) => <ImpactMetric key={metric.label} metric={metric} active={active} />)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;
